<template lang="pug">
AppDialog#edit-recurring-job-settings-dialog(
  show
  size="smedium"
  has-footer
  append-to-body
  title="Edit recurring settings"
  @close="$emit('cancel')"
)
  p These changes will be applied to all occurrences of this job.

  template(#footer)
    AppButton.mr-15(@click="$emit('cancel')") Cancel
    AppButton(
      type="primary"
      @click="$emit('confirm')"
    ) Save
</template>

<script>
export default {
  name: 'WorkOrdersEditRecurringJobSettingsDialog',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
